import APIBase from "./APIBase";

/**
 * @typedef PermissionsService
 * @type {PermissionsService}
 */
export class SalesAgentsService extends APIBase {
    /**
     * @param {string} apiUrl
     * @param { import("../Stores/SessionStore").SessionStore } sessionStore
     * */
    constructor(apiUrl, sessionStore) {
        super(apiUrl + "SalesAgents", sessionStore);
    }

    /**
     * @returns {Promise<Object>} A promise that resolves to the list of Sales Agents.
     */
    async GetSalesAgents() {
        return this.Get("GetSalesAgents");
    }

    async UpdateSalesAgents(salesAgents) {
        return this.Post("UpdateSalesAgents", salesAgents);
    }
}